export default function (context, val) {
    context.commit('set_data', val)
}